<template>
  <div>
    <div class="container">
      <article class="message is-info">
        <div class="message-header large">
          <p>Update 05/12/2019 09:36PM</p>
          <!-- <button class="delete" aria-label="delete"></button> -->
        </div>
        <div class="message-body medium">
          <ul>
            <li>Removed penalties from penalty breakdown where there have been none taken / drawn.</li>
            <li>Added game by game taken / drawn graph.</li>
          </ul>
        </div>
      </article>
    </div>
    <article class="is-parent box">
    <h1 class="title has-text-centered">Season Totals</h1>
    <season-totals-menu name="penalty-minutes"></season-totals-menu>
     <section id="gameFilters">
      <div class="is-parent  is-vertical">
      <article class="is-child box">
        <h2 class="subtitle"><b>Filters</b></h2>
          <div class="columns">
            <div class="column is-3">
              <label class="label">Season</label>
              <div class="control">
                <div class="select">
                  <select v-model="YearSelected" @change="fetchSeasonStats">
                    <option value=2022>2022-2023</option>
                    <option value=2019>2019-2020</option>
                    <option value=2018>2018-2019</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="column is-3">
              <label class="label">Competition</label>
              <div class="control">
                <div class="select">
                  <select v-model="CompetitionSelected"  @change="fetchSeasonStats">
                    <option v-for="option in CompetitionOptions" v-bind:value="option.value" v-bind:key="option.value">{{option.text}}</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
          <div class="columns">
              <div class="column is-4">
                <label class="label">Opponent</label>
                <div class="control">
                  <div class="select">
                    <select  v-model="OpponentSelected"  @change="fetchSeasonStats">
                      <option v-for="option in OpponentOptions" v-bind:value="option.value" v-bind:key="option.value">{{option.text}}</option>
                    </select>
                  </div>
                </div>
            </div>
            <div class="column is-5">
              <label class="label">Venue</label>
              <div class="control">
                <div class="select">
                  <select v-model="VenueSelected"  @change="fetchSeasonStats">
                    <option v-for="option in VenueOptions" v-bind:value="option.value" v-bind:key="option.value">{{option.text}}</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="column is-4">
                <label class="label">Limit</label>
                <div class="control">
                  <div class="select">
                    <select v-model="LimitSelected" @change="fetchSeasonStats">
                      <option v-for="option in LimitOptions" v-bind:value="option.value" v-bind:key="option.value">{{option.text}}</option>
                    </select>
                  </div>
                </div>
            </div>
          </div>
        </article>
      <data-table id="Filtered Games" heading="Filtered Games" v-bind:headers="FilterHeadings" v-bind:tableData="GameFilter"></data-table>
      </div>
    </section>
    </article>
   
    <section id="players">
      <div class="is-parent is-vertical">
        <data-table  defaultShow="true" id="PIM" heading="Penalty Minutes">
          <template slot="filter">
          <label class="label">Penalty Type</label>
          <div class="control">
            <div class="select">
              <select v-model="PenaltyTypeSelected"  @change="fetchSeasonStats">
                <option value=0>Major & Minor</option>
                <option value=1>Minor</option>
                <option value=2>Major</option>
                <option value=3>Misconduct</option>
                <option value=3>All</option>
              </select>
            </div>
          </div>
          <label class="label">Sort</label>
          <div class="control">
            <div class="select">
             <select v-model="FilterSelected" @change="sortByPIMData">
               <option v-for="option in PIMChartFilters" v-bind:value="option.value" v-bind:key="option.value">{{option.text}}</option>
             </select>
            </div>
          </div>
          </template>
          <div slot="graph">
            <chart :type="'horizontalBar'" :data="pim_chart_totals" :options="bar_options" style=""></chart>
            <chart :type="'horizontalBar'" :data="pim_chart_diff" :options="bar_options" style=""></chart>
          </div>
        </data-table>
        <data-table  defaultShow="true" id="PIM" heading="Penalty Minutes by Infraction" v-bind:headers="['Infraction', 'Drawn', 'Taken', 'Diff']" v-bind:tableData="sortByPIMInfraction">
          <template slot="filter">
          <label class="label">Penalty Type</label>
          <div class="control">
            <div class="select">
              <select v-model="PenaltyTypeSelected"  @change="fetchSeasonStats">
                <option value=0>Major & Minor</option>
                <option value=1>Minor</option>
                <option value=2>Major</option>
                <option value=3>Misconduct</option>
                <option value=3>All</option>
              </select>
            </div>
          </div>
          <label class="label">Sort</label>
          <div class="control">
            <div class="select">
             <select v-model="FilterSelected" @change="sortByPIMInfraction">
               <option v-for="option in PIMChartFilters" v-bind:value="option.value" v-bind:key="option.value">{{option.text}}</option>
             </select>
            </div>
          </div>
          </template>
          <div slot="graph">
            <chart :type="'horizontalBar'" :data="pim_by_infraction" :options="bar_options" style=""></chart>
          </div>
        </data-table>
        <data-table  defaultShow="true" id="PIM" heading="Penalty Minutes by Team" v-bind:headers="['Team', 'Drawn', 'Taken', 'Diff' ,'Most Common Taken', 'Most Common Drawn']" v-bind:tableData="sortByPIMTeam">
          <template slot="filter">
          <label class="label">Penalty Type</label>
          <div class="control">
            <div class="select">
              <select v-model="PenaltyTypeSelected"  @change="fetchSeasonStats">
                <option value=0>Major & Minor</option>
                <option value=1>Minor</option>
                <option value=2>Major</option>
                <option value=3>Misconduct</option>
                <option value=3>All</option>
              </select>
            </div>
          </div>
          <label class="label">Sort</label>
          <div class="control">
            <div class="select">
              <select v-model="FilterSelected"  @change="sortByPIMTeam">
                  <option v-for="option in PIMChartFilters" v-bind:value="option.value" v-bind:key="option.value">{{option.text}}</option>
                </select>
              </div>
          </div>
          </template>
          <div slot="graph">
            <chart :type="'horizontalBar'" :data="pim_by_team" :options="bar_options" style=""></chart>
          </div>
        </data-table>
        <data-table  defaultShow="true" id="PIM" heading="Penalty Minutes - All Data" v-bind:headers="PIMHeadings" v-bind:tableData="sortByPIMData">
          <template slot="filter">
          <label class="label">Sort</label>
          <div class="control">
            <div class="select">
              <select v-model="FilterSelected"  @change="sortByPimData">
                <option v-for="option in PIMPlayerFilters" v-bind:value="option.value" v-bind:key="option.value">{{option.text}}</option>
              </select>
            </div>
          </div>
          <label class="label">Penalty Type</label>
          <div class="control">
            <div class="select">
              <select v-model="PenaltyTypeSelected"  @change="fetchSeasonStats">
                <option value=0>Major & Minor</option>
                <option value=1>Minor</option>
                <option value=2>Major</option>
                <option value=3>Misconduct</option>
                <option value=3>All</option>
              </select>
            </div>
          </div>
          </template>
          <div slot="graph">
            <chart :type="'horizontalBar'" :data="chartData" :options="bar_options" style=""></chart>
          </div>
        </data-table>
      </div>
      <div class="box">
       <apexchart type="line" height=350 :options="lastFiveOptions" :series="pim_by_last_five" ref="lastFiveChart"></apexchart>
      </div>
    </section>
  </div>
</template>
<script>
import DataTable from '../data-table'
import SubTable from '../sub-table'
import SeasonTotals from '../season-totals-menu'
import Chart from 'vue-bulma-chartjs'
import _ from 'lodash'
import VueApexCharts from 'vue-apexcharts'
export default {
  components: {
    'data-table': DataTable,
    'sub-table': SubTable,
    'season-totals-menu': SeasonTotals,
    apexcharts: VueApexCharts,
    Chart
  },
  data () {
    return {
      GameFilter: [],
      CompetitionOptions: [],
      VenueOptions: [],
      OpponentOptions: [],
      SituationOptions: [],
      PeriodOptions: [],
      LimitOptions: [],
      YearSelected: 2022,
      CompetitionSelected: 'EIHL_Challenge_Cup',
      VenueSelected: 0,
      OpponentSelected: 0,
      PeriodSelected: 0,
      SituationSelected: 0,
      LimitSelected: 0,
      FilterSelected: 'total_diff',
      PIMData: [],
      PenaltyTypeOptions: [],
      PenaltyTypeSelected: 0,
      PenaltyByInfraction: [],
      PenaltyByTeam: [],
      PenaltyLastFive: [],
      PIMPlusMinusHeading: [
        {text: 'Total +/-', value: 'total_diff'}
      ],
      PIMHeadings: [
        '#',
        'GP',
        'Drawn',
        'Taken',
        'Diff',
        'Drawn OZ',
        'Taken OZ -',
        'OZ Diff',
        'Drawn NZ',
        'Taken NZ',
        'NZ DIFF',
        'Taken DZ',
        'Drawn DZ',
        'DZ Diff'
      ],
      PIMPlayerFilters: [
        {text: 'OZ Drawn', value: 'oz_drawn'},
        {text: 'OZ Taken', value: 'oz_taken'},
        {text: 'OZ Diff', value: 'oz_diff'},
        {text: 'NZ Drawn', value: 'nz_drawn'},
        {text: 'NZ Taken', value: 'nz_taken'},
        {text: 'NZ Diff', value: 'nz_diff'},
        {text: 'DZ Drawn', value: 'dz_drawn'},
        {text: 'DZ Taken', value: 'dz_taken'},
        {text: 'DZ Diff', value: 'dz_diff'},
        {text: 'Total Drawn', value: 'total_drawn'},
        {text: 'Total Taken', value: 'total_taken'},
        {text: 'Total Diff', value: 'total_diff'}
      ],
      PIMChartFilters: [
        {text: 'Drawn', value: 'total_drawn'},
        {text: 'Taken', value: 'total_taken'},
        {text: 'Diff', value: 'total_diff'}
      ],
      sortByPimDiffSelected: 'total_diff',
      bar_options: {
        title: {
          display: false,
          text: 'Data Chart'
        },
        tooltips: {
          mode: 'nearest',
          intersect: true,
          position: 'nearest',
          autoSkip: false
        },
        responsive: true,
        scaleOverride: true,
        scaleStepWidth: 1,

        scales: {
          xAxes: [{
            stacked: true,
            maxBarThickness: 60,
            ticks: {
              autoSkip: false,
              reverse: false
            }
          }],
          yAxes: [{
            stacked: true,
            maxBarThickness: 60,
            ticks: {
              autoSkip: false,
              beginAtZero: true,
              reverse: true
            }
          }]
        }
      },
      lastFiveSeries: [],
      lastFiveOptions: {
        chart: {
          title: {
            text: 'Taken / Drawn Last 5 Games',
            align: 'left',
            enabled: true
          },
          toolbar: { show: false },
          height: 350,
          zoom: {
            enabled: false
          },
          stroke: {
            curve: 'smooth',
            lineCap: 'butt'
          }
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          curve: 'straight'
        },
        title: {
          text: 'Season Taken / Drawn',
          align: 'left'
        },
        markers: {
          size: 6,
          shape: 'circle',
          radius: 4,
          hover: {
            sizeOffset: 3
          }
        },
        xaxis: {
          type: 'category',
          categories: []
        },
        plotOptions: {
        }
      }
    }
  },
  computed: {
    sortByPIMData: function () {
      return _.orderBy(this.PIMData, this.FilterSelected, ['desc'])
    },
    sortByPIMTeam: function () {
      return _.orderBy(this.PenaltyByTeam, this.FilterSelected, ['desc'])
    },
    sortByPIMInfraction: function () {
      return _.orderBy(this.PenaltyByInfraction, this.FilterSelected, ['desc'])
    },
    pim_by_team () {
      let labels = []
      for (var label of this.sortByPIMTeam) {
        labels.push(label.team)
      }
      let data = {
        labels: labels
      }
      data.datasets = []
      let drawn = []
      let taken = []
      for (var pen of this.sortByPIMTeam) {
        drawn.push(pen.total_drawn)
        taken.push(-pen.total_taken)
      }
      data.datasets = [{
        data: taken,
        label: 'Taken',
        backgroundColor: 'rgba(255, 99, 132, 1)',
        borderColor: 'rgba(255, 99, 132, 1)'
      },
      {
        data: drawn,
        label: 'Drawn',
        backgroundColor: 'rgba(255, 206, 86, 1)',
        borderColor: 'rgba(255, 206, 86, 1)'
      }]
      return data
    },
    pim_by_infraction () {
      let infractionLabels = []
      for (var label of this.sortByPIMInfraction) {
        infractionLabels.push(label.penalty_type)
      }
      let data = {
        labels: infractionLabels
      }
      data.datasets = []
      let drawn = []
      let taken = []
      for (var pen of this.sortByPIMInfraction) {
        drawn.push(pen.total_drawn)
        taken.push(-pen.total_taken)
      }
      data.datasets = [{
        data: taken,
        label: 'Taken',
        backgroundColor: 'rgba(255, 99, 132, 1)',
        borderColor: 'rgba(255, 99, 132, 1)'
      },
      {
        data: drawn,
        label: 'Drawn',
        backgroundColor: 'rgba(255, 206, 86, 1)',
        borderColor: 'rgba(255, 206, 86, 1)'
      }]
      return data
    },
    pim_chart_totals () {
      let playerLabels = []
      for (var label of this.sortByPIMDiffData) {
        if (label.player !== 'Team') {
          playerLabels.push(label.player)
        }
      }
      let data = {
        labels: playerLabels
      }
      data.datsets = []
      let drawn = []
      let taken = []
      for (var pen of this.sortByPIMDiffData) {
        if (pen.player !== 'Team') {
          drawn.push(pen.total_drawn)
          taken.push(-pen.total_taken)
        }
      }
      data.datasets = [{
        data: taken,
        label: 'Taken',
        backgroundColor: 'rgba(255, 99, 132, 1)',
        borderColor: 'rgba(255, 99, 132, 1)'
      },
      {
        data: drawn,
        label: 'Drawn',
        backgroundColor: 'rgba(255, 206, 86, 1)',
        borderColor: 'rgba(255, 206, 86, 1)'
      }]
      return data
    },
    pim_chart_diff () {
      let playerLabels = []
      for (var label of this.sortByPIMDiffOnlyData) {
        playerLabels.push(label.player)
      }
      let data = {
        labels: playerLabels
      }
      data.datsets = []
      let differential = []

      for (var pen of this.sortByPIMDiffOnlyData) {
        differential.push(pen.total_diff)
      }
      data.datasets = [{
        data: differential,
        label: 'Differential',
        backgroundColor: 'rgba(54, 162, 235, 1)',
        borderColor: 'rgba(54, 162, 235, 1)'
      }]
      return data
    },
    sortByPIMDiffOnlyData: function () {
      return _.orderBy(this.PIMData, 'total_diff', ['desc'])
    },
    sortByPIMDiffData: function () {
      // taken, drawn,  diff
      return _.orderBy(this.PIMData, this.FilterSelected, ['desc'])
    },
    sortByPIMDataChart: function () {
      let orderedData = this.sortByPIMData
      return _.map(orderedData, this.FilterSelected)
    },
    chartData: function () {
      let playerLabels = []
      for (var label of this.sortByPIMData) {
        playerLabels.push(label.player)
      }
      let data = {
        labels: playerLabels
      }
      data.datsets = []
      data.datasets = [{
        data: this.sortByPIMDataChart,
        label: '+/-  ' + this.FilterSelected,
        backgroundColor: 'rgba(54, 162, 235, 1)',
        borderColor: 'rgba(54, 162, 235, 1)'
      }]
      return data
    },
    pim_by_last_five () {
      this.lastFiveSeries = [{name: 'Drawn', data: []}]
      this.lastFiveSeries.push({name: 'Taken', data: []})
      let cats = []
      // this.lastFiveSeries.push({name: 'Diff', data: []})
      for (var stat of this.PenaltyLastFive) {
        // this.lastFiveOptions.labels.push(stat.match_date)
        cats.push(stat.match_date)
        this.lastFiveSeries[0].data.push(stat.taken)
        this.lastFiveSeries[1].data.push(stat.drawn)
      }
      this.lastFiveOptions = {
        ...this.lastFiveOptions,
        ...{
          xaxis: {
            categories: cats
          }
        }
      }
      return this.lastFiveSeries
    }
  },
  methods: {
    fetchSeasonStats () {
      let postData = {
        'year': 2019,
        'competition': this.CompetitionSelected,
        'venue': this.VenueSelected,
        'opponent': this.OpponentSelected,
        'situation': 0,
        'limit': this.LimitSelected,
        'type': this.PenaltyTypeSelected
      }
      console.log('Filter: ' + JSON.stringify(postData))
      this.$http
        .post('https://devilsapi.roblutken.com/api/app/season-stats/penalty-minutes', postData, {
          headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=', 'Content-Type': 'application/json' }
        })
        .then(
          response => {
            console.log(response.data)
            this.GameFilter = response.data.games_filter
            this.PIMData = response.data.penalty_minutes
            this.PenaltyByInfraction = response.data.penalty_minutes_team_by_type
            this.PenaltyByTeam = response.data.penalty_minutes_by_team
            this.PenaltyLastFive = response.data.penalty_minutes_last_five
          },
          response => {}
        )
    },
    fetchFilterOptions () {
      this.$http.get('https://devilsapi.roblutken.com/api/app/season-stats/filters/', {
        headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' }
      }).then(
          response => {
            // console.log(response.data)
            let venue = response.data.venue
            this.VenueOptions.push({text: 'All', value: 0})
            for (var i = 0; i < venue.length; i++) {
              this.VenueOptions.push({text: venue[i].location, value: venue[i].location})
            }
            let opponent = response.data.teams
            this.OpponentOptions.push({text: 'All', value: 0})
            for (var j = 0; j < opponent.length; j++) {
              if (opponent[j].id !== '1') {
                this.OpponentOptions.push({text: opponent[j].name, value: opponent[j].id})
              }
            }
            let situations = response.data.situations
            this.SituationOptions.push({text: 'All', value: 0})
            this.SituationOptions.push({text: '--Primary Situations--', value: -6})
            this.SituationOptions.push({text: 'Even Handed', value: -1})
            this.SituationOptions.push({text: 'Power Play', value: -2})
            this.SituationOptions.push({text: 'Short Handed', value: -3})
            this.SituationOptions.push({text: 'Empty Net', value: -4})
            this.SituationOptions.push({text: '--Secondary Situations--', value: -5})
            for (var s = 0; s < situations.length; s++) {
              this.SituationOptions.push({text: situations[s].secondary_situation, value: situations[s].id})
            }
            this.CompetitionOptions.push({text: 'All', value: 0})
            this.CompetitionOptions.push({text: 'EIHL & Challenge Cup', value: 'EIHL_Challenge_Cup'})
            this.CompetitionOptions.push({text: 'EIHL', value: 'EIHL'})
            this.CompetitionOptions.push({text: 'Challenge Cup', value: 'Challenge-Cup'})
            this.CompetitionOptions.push({text: 'Pre-Season', value: 'Pre-Season'})
            this.CompetitionOptions.push({text: 'Playoffs', value: 'Playoffs'})
            this.CompetitionOptions.push({text: 'CHL', value: 'CHL'})

            this.PeriodOptions.push({text: 'All', value: 0})
            this.PeriodOptions.push({text: 'Period 1', value: 1})
            this.PeriodOptions.push({text: 'Period 2', value: 2})
            this.PeriodOptions.push({text: 'Period 3', value: 3})
            this.PeriodOptions.push({text: 'Period OT', value: 4})
            this.PeriodOptions.push({text: 'Period Shootout', value: 5})

            this.LimitOptions.push({text: 'All', value: 0})
            this.LimitOptions.push({text: '5 Games', value: 5})
            this.LimitOptions.push({text: '10 Games', value: 10})
            this.LimitOptions.push({text: '20 Games', value: 20})
          }
        )
    }
  },
  created () {
    this.fetchSeasonStats()
    this.fetchFilterOptions()
  }
}
</script>
<style>
#fixed-div {
    position: fixed;
    top: 1em;
    right: 1em;
}
</style>



// WEBPACK FOOTER //
// penalty-minutes.vue?d7c00af2